import { Component, Inject, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeploymentService } from '../../deployment.service';
import { WmsMessageComponent } from '@wms/app/components/wms-message/wms-message.component';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from "@wms/components";

@Component({
  selector: 'wms-deploy-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent
  ],
  templateUrl: './deploy-dialog.component.html',
  styleUrls: ['./deploy-dialog.component.less']
})
export class DeployDialogComponent extends BaseComponent {
  deployService: DeploymentService
  projectName: string
  dialogTitle: string
  manageDeployedAppsUrl: string
  appBaseMetaInfo: any;
  baseURL = 'assets'

  constructor(@Inject("APP_BUILD_META_INFO") appBaseMetaInfo: any) {
    super();
    this.appBaseMetaInfo = appBaseMetaInfo;
    this.baseURL = this.appBaseMetaInfo.CDN_BASE_URL ? this.appBaseMetaInfo.CDN_BASE_URL + this.baseURL : this.baseURL;
    this.deployService = inject(DeploymentService);
    this.projectName = this.projectService.getDetails().name
    this.dialogTitle = `${this.locale.LABEL_DEPLOYING_APP} ${this.projectName}`
    this.manageDeployedAppsUrl = `/deployed-apps/app/main.html#/app/${this.projectService.getProjectEdnDetails().id}`
  }

  getInspectionDialogTxt() {
    switch (this.deployService.inspectionState) {
      case this.deployService.INSP_RUN: return this.locale.LABEL_DEPLOY_INSPECT_CHECKING;
      case this.deployService.INSP_WARN: return this.locale.LABEL_DEPLOY_INSPECT_WARNINGS;
      case this.deployService.INSP_ERR: return this.locale.LABEL_DEPLOY_INSPECT_ERRORS;
      case this.deployService.INSP_SUCC: return this.locale.LABEL_DEPLOY_INSPECT_NO_ERRORS;
      default: return this.locale.LABEL_DEPLOY_INSPECT_CHECKING;
    }
  }

  getActionButtonTxt() {
    switch (this.deployService.inspectionState) {
      case this.deployService.INSP_ERR: return this.locale.LABEL_DEPLOY_CHECK_INSPECT_RESULT;
      case this.deployService.INSP_RUN:
      case this.deployService.INSP_WARN:
      case this.deployService.INSP_SUCC:
      default: return this.deployService.deploying ? this.locale.LABEL_CLOSE : this.locale.LABEL_DEPLOY_RUN_IN_BG;
    }
  }

}
